var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityFeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 1.5H8.7C6.17977 1.5 4.91965 1.5 3.95705 1.99047C3.11032 2.4219 2.4219 3.11031 1.99047 3.95704C1.5 4.91965 1.5 6.17976 1.5 8.7V21.3C1.5 23.8202 1.5 25.0804 1.99047 26.043C2.4219 26.8897 3.11032 27.5781 3.95705 28.0095C4.91965 28.5 6.17977 28.5 8.7 28.5H21.3C23.8202 28.5 25.0804 28.5 26.043 28.0095C26.8897 27.5781 27.5781 26.8897 28.0095 26.043C28.5 25.0804 28.5 23.8202 28.5 21.3V8.7C28.5 6.17976 28.5 4.91965 28.0095 3.95704C27.5781 3.11031 26.8897 2.4219 26.043 1.99047C25.0804 1.5 23.8202 1.5 21.3 1.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 13.5H15.75M23.25 19.5H15.75M23.25 7.5H15.75M10.5 1.5L10.5 28.5M8.7 1.5H21.3C23.8202 1.5 25.0804 1.5 26.043 1.99047C26.8897 2.4219 27.5781 3.11031 28.0095 3.95704C28.5 4.91965 28.5 6.17976 28.5 8.7V21.3C28.5 23.8202 28.5 25.0804 28.0095 26.043C27.5781 26.8897 26.8897 27.5781 26.043 28.0095C25.0804 28.5 23.8202 28.5 21.3 28.5H8.7C6.17977 28.5 4.91965 28.5 3.95705 28.0095C3.11032 27.5781 2.4219 26.8897 1.99047 26.043C1.5 25.0804 1.5 23.8202 1.5 21.3V8.7C1.5 6.17976 1.5 4.91965 1.99047 3.95704C2.4219 3.11031 3.11032 2.4219 3.95705 1.99047C4.91965 1.5 6.17977 1.5 8.7 1.5Z",
    stroke: "#F8D144",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityFeed);
export default __webpack_public_path__ + "static/media/activity-feed.f8420547.svg";
export { ForwardRef as ReactComponent };